import { render, staticRenderFns } from "./complaintTypes.vue?vue&type=template&id=9899d92e&scoped=true"
import script from "./complaintTypes.vue?vue&type=script&lang=js"
export * from "./complaintTypes.vue?vue&type=script&lang=js"
import style0 from "./complaintTypes.vue?vue&type=style&index=0&id=9899d92e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9899d92e",
  null
  
)

export default component.exports